// @ts-check
import './status-label.css';
import { h } from 'preact';

/**
 * @param {object} props
 * @param {any} props.children
 * @param {import('../../types').Status} props.status
 */
export default function StatusLabel({
	children,
	status
}) {
	return (
		<span className={`status-label-container status-${status.value}`}>
			{children || status.label}
		</span>
	);
}
